<template>
<div v-if="useraccess.length > 0">
    <v-card>
        <v-card-title v-show="!isLoggedInUserActive">
            <label style="color: red">{{ $t("msguserisnotactive") }}</label>
        </v-card-title>
        <v-data-table :headers="headers" :items="headcount" :search="search" v-show="isLoggedInUserActive" :footer-props="{
          itemsPerPageOptions: tableItemsPerPage,
          itemsPerPageText: rowsperpage,
        }" :options="options">
            <template v-slot:top>
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card light flat>
                        <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-progress-circular indeterminate color="primary" v-show="deleteinProgress"></v-progress-circular>
                            <v-btn color="blue darken-1" text @click="closeDelete" v-show="!deleteinProgress">Close</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm" v-show="!deleteinProgress">OK</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-toolbar flat dense>
                    <v-btn color="primary" dark @click.stop="openNewEditForm()">{{
              $t("new")
            }}</v-btn>
                    <v-dialog v-model="dialog" max-width="500px">

                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                                <v-spacer></v-spacer>
                                <v-icon @click="close(1)">close</v-icon>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="8" md="4">
                                            <v-select style="background-color: #ffffcc" :items="plants" v-bind:label="$t('plant')" v-model="selecttedplant" item-text="plant" item-value="id" @change="changePlant" :disabled="editedIndex > -1">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="8" md="4">
                                            <v-select style="background-color: #ffffcc" :items="companies" v-bind:label="$t('company')" v-model="selectedcontractor" item-text="value" item-value="id" :disabled="editedIndex > -1">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="8" md="4">
                                            <v-select style="background-color: #ffffcc" :items="maint_grp" v-bind:label="$t('maintgrp')" v-model="selectedmaintgrp" item-text="value" item-value="id" :disabled="editedIndex > -1">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.capex" v-bind:label="$t('capex')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.dailyBusiness" v-bind:label="$t('dailybusiness')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.overheads" v-bind:label="$t('overheads')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="editedItem.others" v-bind:label="$t('others')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div v-if="
                                dateFormat == null ||
                                dateFormat === 'mm/dd/yyyy'
                              ">
                                                        <v-text-field :disabled="editedIndex > -1" v-model="dateFormatted" v-bind:label="$t('infodate')" hint="MM/DD/YYYY format" persistent-hint prepend-icon="event" readonly v-bind="attrs" @blur="date = parseDate(dateFormatted)" v-on="on"></v-text-field>
                                                    </div>
                                                    <div v-if="dateFormat === 'dd/mm/yyyy'">
                                                        <v-text-field :disabled="editedIndex > -1" v-model="dateFormatted" v-bind:label="$t('infodate')" hint="DD/MM/YYYY Format" persistent-hint prepend-icon="event" readonly v-bind="attrs" @blur="date = parseDate(dateFormatted)" v-on="on">
                                                        </v-text-field>
                                                    </div>
                                                </template>
                                                <v-date-picker v-model="date" no-title scrollable>
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="blue darken-1" text @click="close(1)" v-show="!saveInProgress">{{ $t("cancel") }}</v-btn>
                                <v-spacer></v-spacer>
                                <v-progress-circular indeterminate color="primary" v-show="saveInProgress"></v-progress-circular>
                                <v-btn color="primary" dark class="mb-2" @click="save" v-show="!saveInProgress">{{ $t("save") }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-btn color="blue-grey" class="white--text" @click="exportexcel">
                        {{ $t("export") }}
                        <v-icon right dark>arrow_downward</v-icon>
                    </v-btn>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field v-model="search" append-icon="mdi-magnify" v-bind:label="$t('searchall')" single-line hide-details></v-text-field>
                </v-toolbar>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="getUser">Reset</v-btn>
            </template>
        </v-data-table>
    </v-card>
</div>
<div v-else>
    <v-progress-linear indeterminate color="teal" rounded height="8"></v-progress-linear>
</div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import i18n from "@/plugins/i18n";
import requestsMixin from "@/mixins/requests"
import moment from 'moment'
export default {
    mixins: [requestsMixin],
    data() {
        return {
            search: "",
            headcount: [],
            user: null,
            allplants: [],
            plants: [],
            allcompanies: [],
            companies: [],
            allmaint_grp: [],
            maint_grp: [],
            dialog: false,
            statusmessages: [],
            isSucess: false,
            editedIndex: -1,
            selecttedplant: -1,
            selectedcontractor: -1,
            selectedmaintgrp: -1,
            editedItem: {
                id: 0,
                plant: "",
                contractor: "",
                operatingUnit: "",
                dailyBusiness: 0,
                overheads: 0,
                others: 0,
                capex: 0,
                infoDate: new Date().toISOString().substr(0, 10),
                updatedBy: "",
                updatedOn: "",
            },
            defaultItem: {
                id: 0,
                plant: "",
                contractor: "",
                operatingUnit: "",
                dailyBusiness: 0,
                overheads: 0,
                others: 0,
                capex: 0,
                infoDate: new Date().toISOString().substr(0, 10),
                updatedBy: "",
                updatedOn: "",
            },
            date: new Date().toISOString().substr(0, 10),
            dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
            menu: false,
            useraccess: [],
            dateFormat: "",
            tableItemsPerPage: [25, 50, 100, -1],
            options: null,
            saveInProgress: false,
            deleteinProgress: false,
            dialogDelete: false,
        };
    },
    mounted() {
        this.getUser();
    },
    methods: {
        getUser() {
            var self = this;
            if (
                self.$store.state.userDetails != null &&
                self.$store.state.userDetails.userEmail != null
            ) {
                self.user = self.$store.state.userDetails;
                const link4 =
                    window.apiurl +
                    "/userheadcount/myview/" +
                    self.$store.state.userDetails.userEmail;
                axios
                    .get(link4, {
                        withCredentials: true,
                        headers: self.requestHeaders
                    })
                    .then((response1) => {
                        self.useraccess = response1.data;
                        i18n.locale = self.useraccess[0].language;
                        self.dateFormat = self.useraccess[0].preferredDateFormat;
                        if (self.useraccess[0].rowsPerPage != null) {
                            var rowsPrPg =
                                self.useraccess[0].rowsPerPage == "All" ?
                                -1 :
                                parseInt(self.useraccess[0].rowsPerPage);
                            self.options = {
                                itemsPerPage: rowsPrPg,
                            };
                        } else {
                            self.options = {
                                itemsPerPage: 25,
                            };
                        }
                    })
                    .then(() => {
                        self.getDataFromAPI();
                        self.dateFormatted = self.formatDate(
                            new Date().toISOString().substr(0, 10),
                            self.dateFormat
                        );
                    })
                    .then(() => self.getDataFromAPI())
                    .catch((error) => console.log(error));
            } else {
                axios
                    .get(window.apiurl + "/usercontext", {
                        withCredentials: true,
                        headers: self.requestHeaders
                    })
                    .then((response) => {
                        self.user = response.data;
                        const link4 =
                            window.apiurl + "/userheadcount/myview/" + self.user.userEmail;
                        axios
                            .get(link4, {
                                withCredentials: true,
                                headers: self.requestHeaders
                            })
                            .then((response1) => {
                                self.useraccess = response1.data;
                                i18n.locale = self.useraccess[0].language;
                            })
                            .then(() => self.getDataFromAPI())
                            .catch((error) => console.log(error));
                    })
                    .catch((error) => console.log(error));
            }
        },
        getDataFromAPI() {
            var self = this;

            var link = window.apiurl + "/headcount/myview/" + self.user.userEmail;
            if (
                self.$store.state.userDetails != null &&
                self.$store.state.userDetails.userEmail != null
            ) {
                link =
                    window.apiurl +
                    "/headcount/myview/" +
                    self.$store.state.userDetails.userEmail;
            }
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.headcount = response.data;
                  self.headcount.sort(function (a, b) {
                        return new Date(b.infoDate) - new Date(a.infoDate);
                    });
                    var index = 0;
                    for (index = 0; index < self.headcount.length; index++) {
                        // self.headcount[index].infoDate = self.headcount[
                        // index
                        //].infoDate.substr(0, 10);
                        debugger
                       
                        if (self.dateFormat == 'mm/dd/yyyy') {
                            self.headcount[index].infoDate = moment(self.headcount[index].infoDate).format("MM/DD/YYYY")
                            //self.headcount[index].updateOnString!=""? self.headcount[index].updateOnString= moment(self.headcount[index].updatedOn,"MM/DD/yyyy HH:mm:ss").format():self.headcount[index].updatedOn

                            var end_date_moment, end_date;
end_date_moment = moment(new Date(self.headcount[index].updatedOn),"MM-DD-YYYY HH:mm:ss");
end_date = end_date_moment.isValid() ? end_date_moment.format("MM-DD-YYYY HH:mm:ss") : end_date_moment;
                        } else if (self.dateFormat == 'dd/mm/yyyy') {
                            self.headcount[index].infoDate = moment(self.headcount[index].infoDate).format("DD/MM/YYYY")
                             //self.headcount[index].updateOnString!=""? self.headcount[index].updateOnString= moment(self.headcount[index].updatedOn,"DD/MM/yyyy HH:mm:ss").format():self.headcount[index].updatedOn
                                var end_date_moment, end_date;
end_date_moment = moment(new Date(self.headcount[index].updatedOn),"MM-DD-YYYY HH:mm:ss");
end_date = end_date_moment.isValid() ? end_date_moment.format("DD-MM-YYYY HH:mm:ss") : end_date_moment;
                        }
                    }
                    
                    self.getPlantsCompaniesMaintGroups();
                })
                .catch((error) => console.log(error));
        },
        getPlantsCompaniesMaintGroups() {
            var self = this;

            //Get All plants
            const link = window.apiurl + "/plants";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.allplants = response.data;
                    var globalaccess = false;
                    var filterPlant = [];
                    var index = 0;
                    filterPlant = self.useraccess.filter((x) => x.plant == "Global");
                    if (filterPlant != null && filterPlant.length > 0) {
                        for (index = 0; index < self.allplants.length; index++) {
                            self.plants.push(self.allplants[index]);
                        }
                    } else {
                        var filterPlant = [];
                        filterPlant = self.useraccess.filter((x) => x.isActive == "Y");
                        if (filterPlant != null && filterPlant.length > 0) {
                            var index = 0;
                            for (index = 0; filterPlant.length > index; index++) {
                                var plant = self.allplants.filter(
                                    (x) => x.plant == filterPlant[index].plant
                                );
                                self.plants.push(plant[0]);
                            }
                        }
                    }
                })
                .catch((error) => console.log(error));

            //Get All Companies
            const link1 = window.apiurl + "/contractorcompany";
            axios
                .get(link1, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.allcompanies = response.data;
                })
                .catch((error) => console.log(error));

            //Get All Maintainence Groups
            const link2 = window.apiurl + "/maintgrp";
            axios
                .get(link2, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.allmaint_grp = response.data;
                })
                .catch((error) => console.log(error));
        },
        openNewEditForm() {
            this.saveInProgress = false;
            this.dialog = true;
        },
        fnNewHeadcount() {
            this.dialog = true;
            if (this.isUserInOnePlant) {
                var uAccess = this.useraccess.filter((x) => x.isActive == "Y");
                var uPlant = [];
                uPlant = this.plants.filter((x) => x.plant == this.useraccess[0].plant);
                if (uPlant.length > 0) {
                    this.changePlant(uPlant[0].id);
                    this.selecttedplant = uPlant[0].id;
                }
            }
        },
        editItem(item) {
            this.editedIndex = this.headcount.indexOf(item);
            this.editedItem = Object.assign({}, item);
            var selPlant = this.plants.find((x) => x.plant == item.plant);
            if (selPlant != null) {
                this.selecttedplant = selPlant.id;
                this.changePlant(this.selecttedplant);
                var selCompany = this.companies.find((x) => x.value == item.contractor);
                if (selCompany != null) {
                    this.selectedcontractor = selCompany.id;
                }
                var selMaintGrp = this.maint_grp.find(
                    (x) => x.value == item.operatingUnit
                );
                if (selMaintGrp != null) {
                    this.selectedmaintgrp = selMaintGrp.id;
                }
            }
            this.dateFormatted = this.formatDate(
                new Date(this.editedItem.infoDate).toISOString().substr(0, 10),
                this.dateFormat
            );
            this.dialog = true;
        },
        close(isCancel) {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.selecttedplant = -1;
                this.selectedcontractor = -1;
                this.selectedmaintgrp = -1;
                this.statusmessages = [];
                this.dateFormatted = this.formatDate(
                    new Date().toISOString().substr(0, 10),
                    this.dateFormat
                );
            });
            if (isCancel == 1) {
                this.$toast.clear();
            }
        },
        deleteItem(item) {
            this.editedIndex  = this.headcount.indexOf(item);
            this.editedItem.id = item.id
            this.dialogDelete = true;
            this.deleteinProgress = false;
        },
        deleteItemConfirm() {
            this.deleteinProgress = true;
            
            var self = this;
            const link = window.apiurl + "/headcount/delete/" + this.editedItem.id;
            axios
                .delete(link, { withCredentials: true, headers: self.requestHeaders })
                .then(function (response) {
                    if (response.data.isSucess) {
                        self.headcount.splice(self.editedIndex, 1);
                        self.$toast.clear();
                        self.$toast.success(self.$t("msgrecorddeleted"));
                        //alert(response.data.messages[0].message);
                    } else {
                        var index1 = 0;
                        for (
                            index1 = 0; index1 < response.data.messages.length; index1++
                        ) {
                            self.statusmessages.push(response.data.messages[index1]);
                        }
                          self.$toast.clear();
                        self.$toast.success(self.statusmessages[0]);
                    }
                    self.closeDelete()
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        closeDelete() {
            this.dialogDelete = false;
        },
        save() {
            this.saveInProgress = true;
            var datenow = new Date();
            var inputDate = new Date(this.parseDate(this.dateFormatted));
            this.statusmessages = [];

            if (this.selecttedplant == -1) {
                this.saveInProgress = false;
                this.$toast.clear();
                this.$toast.error(this.$t("errplantrequired"), { timeout: false });
            } else if (this.selectedcontractor == -1) {
                this.saveInProgress = false;
                this.$toast.clear();
                this.$toast.error(this.$t("errcompanyrequired"), { timeout: false });
            } else if (this.selectedmaintgrp == -1) {
                this.saveInProgress = false;
                this.$toast.clear();
                this.$toast.error(this.$t("errmaintenancegrouprequired"), {
                    timeout: false,
                });
            } else if (datenow < inputDate) {
                this.saveInProgress = false;
                this.$toast.clear();
                this.$toast.error(this.$t("errinfodate"), { timeout: false });
                this.dateFormatted = "";
            } else {
                this.statusmessages = [];
                this.editedItem.infoDate = this.parseDate(this.dateFormatted);
                this.editedItem.updatedBy = this.user.userEmail;
                this.editedItem.plant = this.plants.find(
                    (x) => x.id == this.selecttedplant
                ).plant;
                this.editedItem.contractor = this.companies.find(
                    (x) => x.id == this.selectedcontractor
                ).value;
                this.editedItem.operatingUnit = this.maint_grp.find(
                    (x) => x.id == this.selectedmaintgrp
                ).value;
                this.editedItem.capex = parseInt(this.editedItem.capex);
                this.editedItem.dailyBusiness = parseInt(this.editedItem.dailyBusiness);
                this.editedItem.overheads = parseInt(this.editedItem.overheads);
                this.editedItem.others = parseInt(this.editedItem.others);
                var self = this;
                if (self.editedIndex > -1) {
                    const link = window.apiurl + "/headcount/update";
                    axios
                        .put(link, this.editedItem, { withCredentials: true, headers: this.requestHeaders })
                        .then(function (response) {
                            if (response.data.isSucess) {
                                Object.assign(
                                    self.headcount[self.editedIndex],
                                    self.editedItem
                                );
                                self.saveInProgress = false;
                                self.$toast.clear();
                                self.$toast.success(self.$t("msgheadcountedited"));
                                self.close();
                            } else {
                                var index = 0;
                                for (
                                    index = 0; index < response.data.messages.length; index++
                                ) {
                                    self.statusmessages.push(response.data.messages[index]);
                                }
                            }
                        })
                        .catch(function (err) {
                            console.log(err);
                        })
                        .finally(() => {
                            self.saveInProgress = false;
                        });
                } else {
                    const link = window.apiurl + "/headcount/create";
                    axios
                        .post(link, this.editedItem, { withCredentials: true, headers: this.requestHeaders })
                        .then(function (response) {
                            if (response.data.isSucess) {
                                if (self.editedIndex > -1) {
                                    //Object.assign(self.subcategories[self.editedIndex], self.editedItem)
                                } else {
                                    const newHeadcount = {
                                        id: 0,
                                        plant: "",
                                        contractor: "",
                                        operatingUnit: "",
                                        dailyBusiness: 0,
                                        overheads: 0,
                                        others: 0,
                                        capex: 0,
                                        infoDate: new Date().toISOString().substr(0, 10),
                                        updatedBy: "",
                                        updatedOn: "",
                                    };
                                    newHeadcount.id = response.data.headCount.id;
                                    newHeadcount.plant = response.data.headCount.plant;
                                    newHeadcount.contractor = response.data.headCount.contractor;
                                    newHeadcount.operatingUnit =
                                        response.data.headCount.operatingUnit;
                                    newHeadcount.dailyBusiness =
                                        response.data.headCount.dailyBusiness;
                                    newHeadcount.capex = response.data.headCount.capex;
                                    newHeadcount.overheads = response.data.headCount.overheads;
                                    newHeadcount.others = response.data.headCount.others;
                                    newHeadcount.infoDate = response.data.headCount.infoDate;
                                    newHeadcount.updatedBy = response.data.headCount.updatedBy;
                                    newHeadcount.updatedOn = response.data.headCount.updatedOn;
                                    self.headcount.push(newHeadcount);
                                }
                                self.saveInProgress = false;
                                self.$toast.clear();
                                self.$toast.success(self.$t("msgheadcountadded"));
                                self.close();
                            } else {
                                var index = 0;
                                for (
                                    index = 0; index < response.data.messages.length; index++
                                ) {
                                    self.statusmessages.push(response.data.messages[index]);
                                }
                            }
                        })
                        .catch(function (err) {
                            console.log(err);
                        })
                        .finally(() => {
                            self.saveInProgress = false;
                        });
                }
            }
        },
        changePlant(selecetedObj) {
            if (selecetedObj === parseInt(selecetedObj)) {
                this.maint_grp = [];
                this.companies = [];
                var filterPlant = this.plants.filter((x) => x.id == selecetedObj);
                var filterMaintGroup = this.allmaint_grp.filter(
                    (x) => x.plant == filterPlant[0].plant
                );
                var index1 = 0;
                if (filterMaintGroup.length > 0) {
                    for (index1 = 0; index1 < filterMaintGroup.length; index1++) {
                        this.maint_grp.push(filterMaintGroup[index1]);
                    }
                }

                var filterCompanies = this.allcompanies.filter(
                    (x) => x.plant == filterPlant[0].plant
                );
                var index1 = 0;
                if (filterCompanies.length > 0) {
                    var checkGloablAccess = this.useraccess.filter(
                        (x) => x.plant == "Global"
                    );
                    var checkLYBCompany = this.useraccess.filter(
                        (x) => x.plant == filterPlant[0].plant && x.company == "LYB"
                    );
                    if (checkGloablAccess.length > 0 || checkLYBCompany.length > 0) {
                        //if useraccess has Global or LYB then add all company for that plant
                        for (index1 = 0; index1 < filterCompanies.length; index1++) {
                            this.companies.push(filterCompanies[index1]);
                        }
                    } else {
                        var filterPlantCompanies = this.useraccess.filter(
                            (x) => x.plant == filterPlant[0].plant
                        );
                        if (filterPlantCompanies.length > 0) {
                            var index1 = 0;
                            for (index1 = 0; index1 < filterPlantCompanies.length; index1++) {
                                var plantCompany = this.allcompanies.filter(
                                    (x) =>
                                    x.plant == filterPlant[0].plant &&
                                    x.value == filterPlantCompanies[index1].company
                                );
                                var checkCompanyExists = this.companies.filter(
                                    (x) =>
                                    x.plant == filterPlant[0].plant &&
                                    x.value == filterPlantCompanies[index1].company
                                );
                                if (plantCompany.length > 0 && checkCompanyExists.length == 0) {
                                    this.companies.push(plantCompany[0]);
                                }
                            }
                        }
                    }
                }
            }
        },
        formatDate(date, date_format) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            if (date_format == "dd/mm/yyyy") return `${day}/${month}/${year}`;
            else return `${month}/${day}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            var [month, day, year] = [0, 0, 0];
            if (this.dateFormat == "dd/mm/yyyy")[day, month, year] = date.split("/");
            else [month, day, year] = date.split("/");

            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        exportexcel() {
            //this.download = true
            this.JSONToCSVConvertor(this.headcount, "Headcount - Report", true);
        },
        JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
            //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
            var arrData =
                typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

            var CSV = "";
            //Set Report title in first row or line

            CSV += ReportTitle + "\r\n\n";

            //This condition will generate the Label/Header
            if (ShowLabel) {
                var row = "";

                //This loop will extract the label from 1st index of on array
                for (var index in arrData[0]) {
                    //Now convert each value to string and comma-seprated
                    row += index + ",";
                }

                row = row.slice(0, -1);

                //append Label row with line break
                CSV += row + "\r\n";
            }

            //1st loop is to extract each row
            for (var i = 0; i < arrData.length; i++) {
                var row = "";

                //2nd loop will extract each column and convert it in string comma-seprated
                for (var index in arrData[i]) {
                    row += '"' + arrData[i][index] + '",';
                }

                row.slice(0, row.length - 1);

                //add a line break after each row
                CSV += row + "\r\n";
            }

            if (CSV == "") {
                //alert("Invalid data");
                self.$toast.clear();
                self.$toast.error(this.$t("errinvaliddata"), { timeout: false });
                return;
            }

            var filename = "HeadCount_Report.csv";
            var blob = new Blob([CSV], { type: "text/csv;charset=utf-8;" });
            if (navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) {
                    // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ?
                this.$t("newheadcount") :
                this.$t("editheadcount");
        },
        computedDateFormatted() {
            return this.formatDate(this.date, this.dateFormat);
        },
        hasGlobalAccess() {
            var globalaccess = false;
            var filterPlant = [];
            filterPlant = this.useraccess.filter((x) => x.plant == "Global");
            if (filterPlant != null && filterPlant.length > 0) {
                globalaccess = true;
            }
            return globalaccess;
        },
        userstore() {
            return this.$store.state.userDetails;
        },
        rowsperpage() {
            return this.$t("rowsperpage");
        },
        isLoggedInUserActive() {
            var isuseractive = false;
            if (this.useraccess.length > 0) {
                this.useraccess.forEach(function (elem, index) {
                    if (elem.isActive == "Y") {
                        isuseractive = true;
                    }
                });
            }
            return isuseractive;
        },
        headers() {
            return [{
                    text: this.$t("plant"),
                    align: "start",
                    value: "plant",
                },
                { text: this.$t("company"), value: "contractor" },
                { text: this.$t("maintgrp"), value: "operatingUnit" },
                { text: this.$t("dailybusiness"), value: "dailyBusiness" },
                { text: this.$t("capex"), value: "capex" },
                { text: this.$t("overheads"), value: "overheads" },
                { text: this.$t("others"), value: "others" },
                { text: this.$t("infodate"), value: "infoDate" },
                { text: this.$t("updatedby"), value: "updatedBy" },
                { text: this.$t("updatedon"), value: "updatedOn" },
                { text: this.$t("actions"), value: "action", sortable: false },
            ];
        },
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        date(val) {
            this.dateFormatted = this.formatDate(this.date, this.dateFormat);
        },
    },
};
</script>



// WEBPACK FOOTER //
// ./src/components/Home.vue